export default __webpack_public_path__ + "static/media/img6.552785f1.png";